
const UseTermsLM = () => (
  <>
    <h3>Termos e condições gerais de uso do sistema Legal Metrics</h3>

    <p>
      Os serviços do software
      {' '}
      <b>Legal Metrics</b>
      {' '}
      são fornecidos pela
      {' '}
      <b>Juristec</b>
      {' '}
      Sistemas Jurídicos Integrados Ltda ("
      <b>Juristec</b>
      "), pessoa
      jurídica de direito privado, com nome fantasia, inscrita no CNPJ/MF sob o
      nº 27.434.472/0001-09, titular da propriedade intelectual sobre software, website,
      aplicativos, conteúdos e demais ativos relacionados à plataforma
      {' '}
      <b>Legal Metrics</b>
      .
    </p>

    <h3 className="section">1. Do Objeto</h3>
    <p>
      A plataforma visa licenciar o uso de seu software, website, aplicativos e demais ativos de
      propriedade intelectual, fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos
      seus usuários.
    </p>
    <p>
      A plataforma caracteriza-se pela prestação dos serviços de “business intelligence” jurídico,
      que pode ser qualificado como um sistema de processamento de bases de dados na forma de
      relatórios e transformação dos mesmos em modelos gráficos por meio da aplicação de
      templates, cópia de dashboards ou criação de novos indicadores.
    </p>
    <p>
      A plataforma é comercializada através do site de sua provedora
      {' '}
      <a
        href="https://juristecplus.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://juristecplus.com.br
      </a>
      {' '}
      e acessada através do site da URL
      {' '}
      <a
        href="https://legalmetrics.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://legalmetrics.com.br
      </a>
      .
    </p>

    <h3 className="section">2. Da Aceitação</h3>
    <p>
      O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, por tempo
      indeterminado, entre a plataforma e as pessoas físicas ou jurídicas, usuárias do software
      {' '}
      <b>Legal Metrics</b>
      .
    </p>
    <p>
      Ao utilizar a plataforma
      {' '}
      <b>Legal Metrics</b>
      , o usuário aceita integralmente as presentes normas e compromete-se a observá-las.
    </p>
    <p>
      A aceitação do presente instrumento é imprescindível para o acesso e para a utilização de
      quaisquer serviços fornecidos pela empresa. Caso não concorde com as disposições deste
      instrumento, o usuário não deve utilizá-los.
    </p>

    <h3 className="section">3. Do Acesso Dos Usuários</h3>
    <p>
      Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma
      para permitir o acesso ao serviço 24 (vinte e quatro) horas por dia, 7 (sete) dias por
      semana. No entanto, a navegação na plataforma ou em alguma de suas páginas poderá ser
      interrompida, limitada ou suspensa para atualizações, modificações, ações necessárias ao
      seu bom funcionamento e/ou por força de terceiros.
    </p>

    <h3 className="section">4. Do Cadastro</h3>
    <p>
      O acesso às funcionalidades da plataforma exigirá a realização de um cadastro prévio e, a
      depender dos serviços ou produtos escolhidos, o pagamento de determinado valor.
    </p>
    <p>
      Ao se cadastrar, o usuário deverá informar dados completos, recentes e válidos, sendo de sua
      exclusiva responsabilidade manter referidos dados atualizados, bem como o usuário se
      compromete com a veracidade dos dados fornecidos.
    </p>
    <p>
      O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a
      terceiros, responsabilizando-se integralmente pelo uso que deles seja feito.
    </p>
    <p>
      Menores de 18 anos e aqueles que não possuírem plena capacidade civil deverão obter
      previamente o consentimento expresso de seus responsáveis legais para utilização da
      plataforma e dos serviços ou produtos, sendo de responsabilidade exclusiva dos mesmos o
      eventual acesso por menores de idade e por aqueles que não possuem plena capacidade civil
      sem a prévia autorização.
    </p>
    <p>
      Mediante a realização do cadastro o usuário declara e garante expressamente ser plenamente
      capaz, podendo exercer e usufruir livremente dos serviços e produtos.
    </p>
    <p>
      O usuário deverá fornecer um endereço de e-mail válido, através do qual o site realizará
      todas as comunicações necessárias.
    </p>
    <p>
      Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal, a qual
      assegura ao usuário o acesso individual à mesma. Desta forma, compete ao usuário
      exclusivamente a manutenção de referida senha de maneira confidencial e segura, evitando o
      acesso indevido às informações pessoais.
    </p>
    <p>
      Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário,
      que deverá informar prontamente a plataforma em caso de uso indevido da respectiva senha.
    </p>
    <p>
      Não será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é
      pessoal e intransferível.
    </p>
    <p>
      Caberá ao usuário assegurar que o seu equipamento seja compatível com as características
      técnicas que viabilize a utilização da plataforma e dos serviços ou produtos.
    </p>
    <p>
      O usuário poderá, a qualquer tempo, requerer o cancelamento de seu cadastro junto ao sistema
      {' '}
      <b>Legal Metrics</b>
      . O seu descadastramento será realizado o mais rapidamente possível, desde que
      não sejam verificados débitos em aberto.
    </p>

    <h3 className="section">5. Dos Serviços ou Produtos</h3>
    <p>
      A plataforma poderá dsponibilizar para o usuário um conjunto específico de funcionalidades
      e ferramentas para otimizar o uso dos serviços e produtos.
    </p>
    <p>
      Os serviços ou produtos oferecidos estarão descritos no site da provedora
      {' '}
      <a
        href="https://juristecplus.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://juristecplus.com.br
      </a>
      {' '}
      e nas documentações competentes, contendo informações sobre suas características, qualidades,
      quantidades, composição, preço, garantia, prazos de validade e origem, entre outros dados,
      bem como sobre os riscos que apresentam à saúde e segurança do usuário.
    </p>
    <p>
      Antes de finalizar a compra sobre determinado produto ou serviço, o usuário deverá se informar
      sobre as suas especificações e sobre a sua destinação.
    </p>

    <h3 className="section">6. Características do Legal Metrics</h3>
    <p>
      O
      {' '}
      <b>Legal Metrics</b>
      {' '}
      consiste em um software as a service (SAAS) de Business Intelligence desenvolvido para o setor
      jurídico. Ele permite integrar dados de diversas fontes, como relatórios de ERPs jurídicos,
      planilhas internas ou na nuvem e tabelas SQL e transformá-los em dashboards com indicadores
      estratégicos.
    </p>
    <p>
      O sistema recebe e processa apenas dados estruturados, os quais devem ser encaminhados pela
      CONTRATANTE no formato de tabelas CSV (comma-separated values) ou XLSX (Excel Microsoft Office
      Open XML Format Spreadsheet) ou integradas com relatórios de ERPs jurídicos utilizados pela
      CONTRATANTE ou ainda tabelas extraídas de bancos SQL ou planilhas armazenadas na nuvem.
    </p>
    <p>
      Os tipos de dados a serem inseridos pela CONTRATANTE disponíveis nas diversas fontes de dados,
      para inclusão no Legal Metrics deverão observar os seguintes formatos:
    </p>
    <ul>
      <li>
        <b>Número:</b>
        {' '}
        dado que representa um valor numérico. Poderá ser um número inteiro (integer) ou real (ponto
        flutuante float). Em geral, independente de como os dados são apresentados na interface do
        usuário com os demais sistemas (ERPs ou nuvem), os dados são formatados com “ponto” (“.”)
        como delimitador decimal. No caso de utilização do Google Spreadsheets ou Microsoft One
        Drive, qualquer formatação numérica tende a ser aceita (aqui estamos nos referindo a
        delimitador decimal, separador de milhar, formatação monetária, entre outras).
      </li>
      <li>
        <b>Texto:</b>
        {' '}
        variável categórica que representa uma informação qualitativa. É considerada uma sequência
        contínua de caracteres ASCII.
      </li>
      <li>
        <b>Data:</b>
        {' '}
        variável do tipo data que devem ser recebidas nos formatos AAAA-MM-DD ou DD/MM/AAAA.
      </li>
    </ul>
    <p>
      Os dados que não estejam no formato especificado poderão não ser aceitos pelo
      {' '}
      <b>Legal Metrics</b>
      {' '}
      , que não processará integralmente o arquivo que os contém e indicará ao usuário o motivo
      do não processamento.
    </p>
    <p>
      O
      {' '}
      <b>Legal Metrics</b>
      {' '}
      permite que o usuário, no momento da importação dos dados, ou em qualquer outro momento
      após a importação, possa alterar o tipo das colunas das tabelas disponíveis no sistema.
    </p>
    <p>
      O
      {' '}
      <b>Legal Metrics</b>
      {' '}
      é uma aplicação que opera em ambiente computacional virtualizado da JURISTEC+, e é
      utilizada através de navegadores da web (Safari versão 13.0.3, ou superior; Internet
      Explorer versão 11, ou superior; Chrome versão 78.0.3904.70, ou superior, e Firefox versão
      48.0. 51.0.1, ou superior).
    </p>

    <h3 className="section">6.1. Tipos de Usuários</h3>
    <p>
      Há três tipos de perfis de usuários do
      {' '}
      <b>Legal Metrics</b>
      {' '}
      :
      <ul>
        <li>
          <b>Convidado:</b>
          {' '}
          apto a visualizar, realizar download de relatórios e imprimir os dashboards que são
          compartilhados com ele.
        </li>
        <li>
          <b>Cientista:</b>
          {' '}
          apto a carregar (upload) as tabelas de dados, validar as informações, definir, criar
          e visualizar dashboards e  KPIs, criar e exportar os relatórios.
        </li>
        <li>
          <b>Usuário proprietário:</b>
          {' '}
          apto a gerenciar usuários e grupos no sistema, carregar (upload) as bases de dados,
          validar as informações, definir, criar e visualizar dashboards e KPIs, criar e exportar
          relatórios e configurar os relatórios de atualização automática.
        </li>
      </ul>
      <p>
        Ao contratar o
        {' '}
        <b>Legal Metrics</b>
        {' '}
        , é definido o usuário proprietário e as quantidades de usuários Cientistas e Convidados,
        como parte do plano contratado pela CONTRATANTE.
      </p>
      <p>
        A CONTRATANTE poderá contratar junto à JURISTEC+ quantidades adicionais de usuários
        proprietários, cientistas ou usuários convidados para o Legal Metrics, conforme política de
        preços da JURISTEC+.
      </p>
    </p>

    <h3 className="section">6.2. Instalação do Legal Metrics</h3>
    <p>
      Ao término do processo de instalação do Legal Metrics, a CONTRATANTE estará apta a utilizá-lo
      com o conjunto inicial de informações disponibilizadas.
    </p>
    <p>
      A instalação do
      {' '}
      <b>Legal Metrics</b>
      {' '}
      à CONTRATANTE consiste na adoção das seguintes etapas de trabalho:
    </p>
    <ul>
      <li>
        Criação da instância do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        específica para a CONTRATANTE com os respectivos recursos computacionais alocados;
      </li>
      <li>
        Importação e integração das informações iniciais fornecidas pela CONTRATANTE, seja a partir
        de tabelas de dados internas, tabelas de dados extraídas de bases SQL, ou através de
        relatórios de dados gerados por sistemas de gestão de informação (ERPs jurídicos integrados
        ou arquivos em nuvem do usuário);
      </li>
      <li>
        Configuração dos KPIs e dashboards iniciais, como previsto no plano contratado pela
        CONTRATANTE, para a utilização imediata;
      </li>
      <li>
        Reunião de treinamento do sistema para as pessoas selecionadas pela CONTRATANTE.
      </li>
    </ul>
    <p>
      A plataforma
      {' '}
      <b>Legal Metrics</b>
      {' '}
      poderá disponibilizar aos usuários os seguintes treinamentos de utilização:
    </p>
    <ul>
      <li>
        <b>Treinamento Onboarding:</b>
        {' '}
        A ser usufruído durante os 3 primeiros meses de contrato para conhecimento da plataforma do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        . O cliente receberá um link de agenda e selecionará os horários de acordo com a
        disponibilidade de agenda.
      </li>
      <li>
        <b>Treinamento Ongoing:</b>
        {' '}
        A ser usufruído após os 3 primeiros meses e até o final da vigência.
      </li>
    </ul>

    <h3 className="section">6.3. Configurações adicionais</h3>
    <p>
      A CONTRATANTE poderá contratar configurações adicionais disponibilizadas pela JURISTEC+ (“ADD
      ONs”), especificados conforme condições  abaixo
    </p>
    <ul>
      <li>
        <b>Memória Virtual:</b>
        {' '}
        Disponibilização complementar de memória virtual. A memória será utilizada para a
        armazenagem das informações carregadas pela CONTRATANTE, pelos indicadores-chave (KPIs) e
        dashboards construídos, conforme política de preços da JURISTEC+.
      </li>
      <li>
        <b>Módulo integrado de inteligência artificial:</b>
        {' '}
        Disponibilização de um conjunto de agentes de inteligência artificial, integrados ao
        {' '}
        <b>Legal Metrics</b>
        {' '}
        , conforme política de preços constantes do Anexo III e seus respectivos aditamentos. Os
        agentes disponíveis são os seguintes:
        <ol>
          <li>
            <b>Chat com a base de dados:</b>
            {' '}
            Agente de inteligência artificial que permite que o usuário converse com a base de dados
            com o intuito de extrair informações consolidadas a partir do uso de um prompt feito em
            linguagem natural. Todo o histórico de conversas com a base de dados fica armazenado
            para consultas posteriores.
          </li>
          <li>
            <b>Criação de insights inteligentes:</b>
            {' '}
            permite que o usuário crie insights no formato de texto dentro de um dashboard a partir
            de uma base de dados. Os insights inteligentes são dinâmicos e suas informações são
            atualizadas conforme a base de dados é alterada.
          </li>
          <li>
            <b>Quaisquer outros agentes que venham a ser criados:</b>
            {' '}
            se porventura forem introduzidos novos agentes de inteligência artificial no
            {' '}
            <b>Legal Metrics</b>
            {' '}
            , esses agentes poderão estar disponíveis para a CONTRATANTE caso o módulo de
            inteligência artificial esteja incluído no plano contratado.
          </li>
        </ol>
      </li>
    </ul>
    <p>São observadas as seguintes condições:</p>
    <ul>
      <li>
        <b>Natureza da Resposta:</b>
        {' '}
        As respostas fornecidas são geradas automaticamente tendo por base um conjunto de dados
        rodados em rede neural, podendo ser imprecisas, incompletas, desatualizadas e, em casos
        raros, podem ser interpretadas como ofensivas ou inadequadas.
      </li>
      <li>
        <b>Sem Garantias:</b>
        {' '}
        Este serviço contém tecnologia pioneira e é fornecido no estado em que se encontra, não
        sendo garantida sua precisão, relevância ou adequação para qualquer propósito específico.
      </li>
      <li>
        <b>Responsabilidade do Usuário:</b>
        {' '}
        Ao utilizar o módulo de inteligência artificial, é de responsabilidade do usuário usá-lo
        com discernimento, interpretar as respostas com cuidado e consultar fontes adicionais ou
        profissionais quando necessário.
      </li>
    </ul>
    <p>
      As tecnologias de inteligência artificial generativa poderão sofrer alterações ou
      substituições conforme a necessidade da empresa, seja em razão de indisponibilidade, mudanças
      de projeto, ajustes comerciais, decisões técnicas ou estratégicas da CONTRATADA.
    </p>
    <p>
      A CONTRATANTE poderá contratar serviços adicionais disponibilizados pela JURISTEC+,
      especificados conforme abaixo:
    </p>
    <ul>
      <li>
        <b>Dashboards Personalizados:</b>
        {' '}
        Refere-se ao serviço de elaboração de dashboards sob demanda, ou seja, personalizados de
        acordo com os interesses específicos da CONTRATANTE, conforme política de preços da
        JURISTEC+. A execução deste serviço está condicionada à existência de uma base de dados
        disponível da CONTRATANTE. Não está incluído neste serviço nenhum trabalho adicional de
        construção, preparação ou saneamento de uma base de dados. Após a contratação deste serviço,
        a equipe JURISTEC+ fará a avaliação da demanda e, em caso de não possibilidade de
        cumprimento, o serviço não será realizado e, consequentemente, nada será cobrado.
      </li>
      <li>
        <b>J+ integra:</b>
        {' '}
        Pacote de serviço adicional que permite a integração e coleta de informações de ERPs de
        terceiros centrados na web para integração ao Legal Metrics, conforme demanda da CONTRATANTE
        e política de preços da JURISTEC+. A execução deste serviço estará condicionada à
        viabilidade técnica de integração entre o ERP e o Legal Metrics.
      </li>
      <li>
        <b>Consultoria Exclusiva:</b>
        {' '}
        Serviços complementares de consultoria especializada em jurimetria, conforme política de
        preços da JURISTEC+. A execução deste serviço deverá ser acompanhada de reunião prévia entre
        a CONTRATANTE e a equipe especializada da JURISTEC+ para avaliação da viabilidade técnica e
        disponibilidade de dados prévios para sua execução.
      </li>
    </ul>

    <h3 className="section">6.4. Funcionalidades</h3>

    <p>
      O
      {' '}
      <b>Legal Metrics</b>
      {' '}
      simplifica a organização e análise das informações jurídicas através da geração de KPIs,
      validação de base de dados de informações e geração de dashboards para gestão de carteiras
      jurídicas.
    </p>

    <p>
      O
      {' '}
      <b>Legal Metrics</b>
      {' '}
      permite, dentre outras finalidades:
    </p>

    <ul>
      <li>
        atualização automática dos KPIs, conforme as mudanças da base e utilização dos procedimentos
        salvos. Essa funcionalidade permite que o trabalho de execução de um dashboard seja
        realizado uma única vez para depois, ser atualizado constantemente, conforme a fonte das
        informações sejam alteradas (tabelas do ERP, tabelas da nuvem, alterações dos arquivos do
        dispositivo do usuário, entre outras);
      </li>
      <li>
        disponibilizar KPIs jurídicos prontos e agrupados em dashboards, como por exemplo:
        “Trabalhista”, “Cível”, “Acordos”, “Financeiro”, Estratégico”, entre outros;
      </li>
      <li>
        criar livremente KPIs em diversas combinações;
      </li>
      <li>
        gerar gráficos que possuem filtros na própria interface do dashboard ou KPI;
      </li>
      <li>
        realizar funções matemáticas que permitem a implantação de jurimetria financeira.
      </li>
      <li>
        possibilidade de realização de download dos arquivos e bases do sistema, assim como dos
        relatórios filtrados responsáveis pelos diversos KPIs criados. Todos os KPIs podem ser
        exportados no formato de figura (extensão PNG) para que sejam utilizados em apresentações
        externas.
      </li>
      <li>
        Criação de relatórios customizados a partir das bases de dados importadas no sistema.
      </li>
      <li>
        O sistema possui um tracking de todos os arquivos, dashboards e KPIs de forma que é
        possível verificar os responsáveis pela criação, as últimas atualizações e o passo a passo
        utilizado para a criação dos KPIs.
      </li>
      <li>
        Possibilidade de criação de histórico de base de dados, permitindo a comparação de mudanças
        na base ao longo do tempo nos diversos períodos em que os históricos foram armazenados.
      </li>
      <li>
        Possibilidade de compartilhamento de dashboards externamente, permitindo que terceiros
        interessados possam visualizar dashboards executivos de forma simples e intuitiva.
      </li>
      <li>
        O sistema possui um sistema de suporte interno que permite que o usuário crie tickets com
        dúvidas que serão prontamente respondidas pelo time técnico da Juristec+.
      </li>
    </ul>

    <h3 className="section">6.5. Interface com os usuários</h3>
    <p>
      O
      {' '}
      <b>Legal Metrics</b>
      {' '}
      possui as seguintes interfaces para os usuários:
    </p>
    <ul>
      <li>
        <b>Interface de Dashboards:</b>
        {' '}
        Apresenta todos os dashboards próprios de um usuário ou os
        dashboards compartilhados por outros usuários. Nesta interface, os usuários podem criar
        novos dashboards, compartilhar seus próprios dashboards, clonar dashboards, apagar
        dashboards, acessar e filtrar informações, entre outras funcionalidades.
      </li>
      <li>
        <b>Interface de Arquivos:</b>
        {' '}
        Repositório de arquivos do sistema. Aqui são inseridas as diversas fontes de dados a
        partir das quais o usuário pode criar seus dashboards e KPI’s. Cada arquivo é identificado
        conforme a sua fonte de origem. Os arquivos que o usuário insere de seu próprio dispositivo
        somente são atualizados quando o usuário atualizar as fonte de dados correspondentes. As
        demais fontes de dados integradas (ERPs, Google Sheets, One Drive, tabelas SQL, entre
        outras) são atualizadas diariamente de forma automática ou por necessidade do próprio
        usuário. Também é permitida a criação e gerenciamento de relatórios extraídos das bases de
        dados dos usuários.
      </li>
      <li>
        <b>Interface do dashboard:</b>
        {' '}
        Interface que apresenta o conjunto dos KPIs que constituem cada um dos dashboards do usuário
        ou de um dashboard compartilhado com este usuário.
      </li>
      <li>
        <b>Interface de Criação de KPI:</b>
        {' '}
        Interface que permite a criação dos KPIs a partir da seleção de variáveis de um arquivo,
        incorporando filtros e agrupamentos e estilos. Permite a seleção do tipo de gráfico e sua
        pré-visualização.
      </li>
      <li>
        <b>Interface de Gerenciamento da instância:</b>
        {' '}
        Interface onde os usuários proprietários e cientistas podem gerenciar os usuários atuais do
        sistema e/ou criar novos usuários. Nesta interface são listados todos os usuários, é
        possível fazer o bloqueio ou remoção de um usuário existente ou criar novos usuários para a
        utilização da ferramenta. Os usuários proprietários podem criar e gerenciar grupos inteiros
        de usuários, como por exemplo, replicando departamentos existentes em sua própria
        instituição.
      </li>
    </ul>

    <h3 className="section">6.6. Acordo de Nível de Serviço</h3>
    <p>
      Estão previstos os seguintes níveis de serviço para a utilização do
      {' '}
      <b>Legal Metrics</b>
      {' '}
      :
    </p>
    <ul>
      <li>
        <b>Intalação do Legal Metrics:</b>
        {' '}
        O tempo máximo para instalação do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        será de 15 (quinze) dias úteis a contar do recebimento da solicitação pela equipe da
        JURISTEC+. O tempo de 15 (quinze) dias está condicionado à disponibilização, por parte do
        cliente, de todo e qualquer arquivo e/ou documentação necessária para o onboarding inicial
        do sistema. Importante ressaltar que neste período de 15 (quinze) dias, não estão incluídos
        serviços adicionais de integração com novos sistemas (J+ integra) e que podem depender de
        situações externas ao controle da JURISTEC+ ou que dependam de terceiros.
      </li>
      <li>
        <b>Instalação de Dashboards Personalizados:</b>
        {' '}
        Tempo de entrega de até 2 (duas) semanas, limitado a 20 KPIs, podendo o prazo ser estendido
        a depender de atraso por conta da CONTRATANTE. O prazo para a entrega de dashboards
        personalizados está condicionado à disponibilidade, por parte da CONTRATANTE, dos arquivos
        e/ou tabelas completas. Enquanto os arquivos ou tabelas estiverem indisponíveis ou
        incompletos esta tarefa não será executada.
      </li>
      <li>
        <b>Elaboração de Relatórios Integrados:</b>
        {' '}
        Tempo de entrega entre 2 (duas) até 4 (quatro) semanas. Entrega condicionada à viabilidade
        técnica a ser apreciada pela equipe da JURISTEC+. Não sendo possível a integração, não
        caberá nenhuma contrapartida ou indenização a quaisquer das partes.
      </li>
      <li>
        <b>Solicitação de Acesso Individual:</b>
        {' '}
        Para garantir a melhor extração de dados e correção de eventuais erros a CONTRATANTE deverá
        fornecer um acesso do ERP utilizado para a CONTRATADA. Caso não seja possível a liberação do
        acesso, é de responsabilidade do CONTRATANTE viabilizar meios para execução do serviço.
      </li>
      <li>
        <b>Suporte de 1º Nível:</b>
        {' '}
        Trata-se de suporte inicial voltado a orientar o usuário sobre o correto uso do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        , a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou a
        partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+ deverá
        ser de 1 (um) dia útil.
      </li>
      <li>
        <b>Suporte de 2º Nível:</b>
        {' '}
        Trata-se de suporte voltado à resolução de comportamento inesperado do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        , a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou a
        partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+ deverá
        ser de 5 (cinco) dias úteis.
      </li>
      <li>
        <b>Suporte de 3º Nível:</b>
        {' '}
        Trata-se de suporte voltado a resolver questões relacionadas à indisponibilidade do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        , a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou a
        partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+ deverá
        ser de 1 (um) dia útil.
      </li>
    </ul>

    <h3 className="section">7. Características do Antecipei</h3>
    <p>
      O Antecipei consiste em uma solução de monitoramento dos tribunais (TRTs, TJs e TRFs)
      realizando a busca de processos ativos em sistemas dos tribunais brasileiros exclusivamente
      a partir de uma lista de números CNPJs da parte (não são executadas buscas baseadas em CPF
      ou OAB). A partir da busca, que pode ser definida diariamente, a cada dois dias, semanalmente,
      quinzenalmente ou mensalmente, o Antecipei compara seu resultado com uma base de dados
      capturados na busca anterior, alimentando um dashboard apresentado dentro da plataforma
      {' '}
      <b>Legal Metrics</b>
      {' '}
      .
    </p>
    <p>
      A primeira busca é realizada na implantação unicamente para compor a base “viva” que será
      utilizada para fins de comparação na próxima busca do sistema.
    </p>
    <p>
      O entregável do produto Antecipei é um relatório com a lista de processos capturados em
      conjunto com informações de capa disponíveis no momento da busca e algumas outras informações
      relacionadas à operação, como por exemplo a “Data da captura”.
    </p>
    <p>
      O relatório gerado pelo Antecipei é integrado na plataforma
      {' '}
      <b>Legal Metrics</b>
      {' '}
      , contendo dois tipos de processos capturados:
    </p>
    <ol type="I">
      <li>
        <b>Processo Legado:</b>
        {' '}
        todo processo ativo ou retornado pelo sistema do tribunal, obtido na implantação para o CNPJ
        em questão. Para este processo apenas o número de CNJ é apresentado.
      </li>
      <li>
        <b>Processo Capturado na Distribuição:</b>
        {' '}
        todo processo novo obtido após o primeiro dia da captura. Para este processo, os dados de
        capas também serão disponibilizados.
      </li>
    </ol>
    <p>
      Caso o CONTRATANTE ache necessário, para fins de dashboards mais analíticos, ele pode fazer um
      pedido de captura dos dados de capa da base legada contratando um serviço também disponível
      pela JURISTEC+.
    </p>
    <p>
      Para cada CNPJ contratado, o cliente possui uma franquia de busca de processos capturados na
      distribuição estipulada em 100 processos por mês, sendo cobrado um valor adicional de até
      R$ 0,15 para cada processo adicional capturado para aquele CNPJ.
    </p>
    <p>
      A CONTRATANTE fica obrigada a encaminhar um documento a ser anexado à proposta, contendo a
      relação de Tribunais que devem ser buscados por CNPJ. O serviço só será implantado e ficará
      disponível no
      {' '}
      <b>Legal Metrics</b>
      {' '}
      a partir do momento em que este documento for entregue à CONTRATADA.
    </p>
    <p>
      A CONTRATANTE poderá realizar a troca ou adição de CNPJs mediante pedido formalizado por
      e-mail à JURISTEC+, cujo aceite pela JURISTEC+ deverá integrar, para todos os efeitos, como
      aditamento à proposta comercial. Este e-mail deverá conter o CNPJ e a lista de tribunais a
      serem monitorados. No caso de mais de um CNPJ, cada um deverá ter a sua própria lista de
      tribunais. No caso específico de adição de CNPJs, o valor mensal deverá incorporar os novos
      valores constantes dos novos CNPJs adicionados.
    </p>
    <p>
      Todo CNPJ deverá permanecer em monitoramento pelo período mínimo de 3 (três) meses, não
      sendo possível efetuar a sua troca em período inferior. A troca de CNPJ deverá ser executada
      em até 5 (cinco) dias úteis após o aceite pela JURISTEC+.
    </p>
    <p>
      A frequência de monitoramento do produto Antecipei será a descrita na proposta contratada, a
      qual poderá ser alterada mediante mudança do valor padrão e de acordo com uma nova proposta.
    </p>
    <p>
      Ambiente Computacional e Navegadores. O Antecipei é uma aplicação que opera em ambiente
      computacional virtualizado da JURISTEC+, e é utilizada através de navegadores da web
      (Safari versão 13.0.3, ou superior; Internet Explorer versão 11, ou superior; Chrome versão
      78.0.3904.70, ou superior, e Firefox versão 48.0. 51.0.1, ou superior).
    </p>
    <p>
      A CONTRATANTE declara ter ciência de que o Antecipei NÃO SUBSTITUI A NECESSIDADE DE
      ACOMPANHAMENTO JURÍDICO ÀS ATIVIDADES DA CONTRATANTE, sendo uma ferramenta automatizada cuja
      finalidade é facilitar a análise de dados e informações disponibilizados por fontes públicas.
      A JURISTEC+ não se responsabiliza por erro de dados e/ou informações obtidas de fontes
      públicas, nem por quaisquer falhas na captura de tais dados e informações. Nenhuma informação
      ou dado disponibilizados no Antecipei têm a função de substituir informações oficiais
      provenientes de fontes públicas, incluindo, mas não se limitando, a informações provenientes
      de tribunais de justiça, diários oficiais e demais entidades da administração pública direta
      ou indireta, não servindo o Antecipei como instrumento de controle de prazos processuais e
      recebimento de citação.
    </p>
    <p>
      Como o entregável do Antecipei é um relatório disponível para consulta na plataforma
      {' '}
      <b>Legal Metrics</b>
      {' '}
      , a CONTRATADA não disponibilizará este relatório em outro formato, salvo em situações
      críticas operacionais. Para o caso em que o cliente esteja interessado apenas no Antecipei,
      será criada uma instância com funcionalidades limitadas dentro do
      {' '}
      <b>Legal Metrics</b>
      {' '}
      para que o CONTRATANTE tenha acesso a um dashboard padrão dos dados Antecipei e, a partir
      dele, possa fazer download da base conforme sua necessidade. Mesmo nesse formato, e ainda
      que o CONTRATANTE não tenha interesse no
      {' '}
      <b>Legal Metrics</b>
      {' '}
      , algumas de suas funcionalidades estarão mantidas e poderão ser utilizadas.
    </p>
    <p>
      A definição do número e perfis de usuários contratados é aquele constante da proposta
      comercial contratada.
    </p>
    <p>
      Como o Antecipei opera dentro do
      {' '}
      <b>Legal Metrics</b>
      {' '}
      , as interfaces com os usuários são as mesmas disponíveis no
      {' '}
      <b>Legal Metrics</b>
      .
    </p>
    <h3 className="section">7.1. Instalação do Antecipei</h3>
    <p>
      A instalação do Antecipei à CONTRATANTE consiste na adoção das seguintes etapas de trabalho:
    </p>
    <ul>
      <li>
        Criação da instância do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        correspondente para a CONTRATANTE com os respectivos recursos computacionais alocados;
      </li>
      <li>
        Assim que a CONTRATADA receber a lista de CNPJs correspondente, inicia-se, dentro do
        prazo de até 5 (cinco) dias úteis, as capturas das informações iniciais;
      </li>
      <li>
        Após as primeiras capturas, são criados os KPIs e dashboards iniciais com os dados
        obtidos pelas capturas, conforme previsto no plano contratado pela CONTRATANTE, para
        utilização imediata;
      </li>
      <li>
        Reunião de orientação inicial quanto às funcionalidades do Antecipei, templantes de
        dashboards e outros recursos de maior utilidade para a CONTRATANTE.
      </li>
    </ul>
    <p>
      Ao término do processo de instalação do Antecipei, a CONTRATANTE estará apta a utilizá-lo
      com o conjunto inicial de informações disponibilizadas.
    </p>

    <h3 className="section">7.2. Funcionalidades</h3>
    <p>
      O Antecipei simplifica a visualização de processos recém distribuídos dos CNPJs pesquisados
      junto aos tribunais do plano contratado, através da geração de KPIs e geração de dashboards
      e disponibilização do relatório pronto para download na ferramenta
      {' '}
      <b>Legal Metrics</b>
      {' '}
      .
    </p>
    <p>
      O Antecipei, como serviço disponibilizado dentro da plataforma
      {' '}
      <b>Legal Metrics</b>
      {' '}
      , permite, dentre outras finalidades:
    </p>
    <ul>
      <li>
        Visualização dos KPIs e dashboards correspondentes as capturas definidas em contrato, ou
        seja, para as capturas realizadas, serão disponibilizados dashboards gráficos com as
        informações mais relevantes;
      </li>
      <li>
        Visualização e opção de download do relatório, em formato xlsx, das informações de capturas;
      </li>
      <li>
        Atualização do relatório e dos dashboards correspondentes conforme novas capturas sejam
        realizadas de forma automática, permitindo ao CONTRATANTE uma visão sempre atualizada das
        capturas das distribuições da lista de CNPJs fornecidos;
      </li>
      <li>
        Além disso, o CONTRATANTE poderá, por livre e espontânea iniciativa, alterar ou criar novos
        KPIs e dashboards com demais informações que julgar relevante a partir do relatório de
        capturas ou qualquer outra base de dados, ainda que externa ao sistema, conforme os limites
        do plano contratado, aproveitando-se das funcionalidades da plataforma
        {' '}
        <b>Legal Metrics</b>
        {' '}
        .
      </li>
      <li>
        Se utilizar de toda e qualquer funcionalidade adicional do
        {' '}
        <b>Legal Metrics</b>
        {' '}
        disponível no plano contratado;
      </li>
    </ul>

    <h3 className="section">7.3. Desenvolvimento e Atualização</h3>
    <p>
      Na qualidade de titular de todos os direitos de propriedade intelectual sobre o Antecipei,
      caberá exclusivamente à JURISTEC+ realizar os aperfeiçoamentos, atualizações e alterações
      que entender pertinentes no Antecipei, determinando, a seu critério, o lançamento de
      atualizações e novas versões.
    </p>
    <p>
      A JURISTEC+ poderá, a seu critério, aperfeiçoar, atualizar ou alterar as especificações do
      Antecipei.
    </p>

    <h3 className="section">7.4. Política de Segurança da Informação e Privacidade</h3>
    <p>
      Os ambientes de desenvolvimento e produção do Antecipei, os correspondentes processos e o
      próprio produto estão em conformidade com a
      {' '}
      <a
        href="https://legalmetrics.com.br/politica-de-privacidade-legalmetrics.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Política de Segurança da Informação e Privacidade
      </a>
      {' '}
      da JURISTEC+.
    </p>

    <h3 className="section">7.5. Acordo de Nível de Serviço</h3>
    <p>
      O Antecipei, como serviço ofertado dentro da plataforma
      {' '}
      <b>
        Legal Metrics
      </b>
      {' '}
      , quando contratato, terá níveis de serviço similares aqueles previstos para o
      {' '}
      <b>
        Legal Metrics
      </b>
      {' '}
      .
    </p>
    <ul>
      <li>
        <b>Instalação do Antecipei:</b>
        {' '}
        As partes acordam que o tempo máximo para instalação do Antecipei
        será de 15 (quinze) dias úteis a contar do recebimento da solicitação pela equipe da
        JURISTEC+. O tempo de 15 (quinze) dias está condicionado à disponibilização, por parte do
        cliente, de todo e qualquer arquivo e/ou documentação necessária para o onboarding inicial
        do sistema. Importante ressaltar que, neste período de 15 (quinze) dias, não estão incluídos
        serviços adicionais de integração com novos sistemas (serviço especificado na seção 1.4.1.3)
        e que podem depender de situações externas ao controle da JURISTEC+ ou que dependam de
        terceiros.
      </li>
      <li>
        <b>Inclusão / Alteração / Exclusão de CNPJ:</b>
        {' '}
        As partes acordam que o tempo máximo para inclusão, alteração ou exclusão de CNPJ junto à
        plataforma Antecipei será de 5 (cinco) dias úteis a contar do recebimento da solicitação
        pela equipe da JURISTEC+.
      </li>
      <li>
        <b>Formação da Base Legada:</b>
        {' '}
        As partes acordam que o tempo máximo para formação da base legada
        junto à plataforma Antecipei será de 5 (cinco) dias úteis a contar do recebimento da
        solicitação pela equipe da JURISTEC+.
      </li>
      <li>
        <b>Tempo de Comunicação de Novos Processos:</b>
        {' '}
        As partes acordam que o tempo máximo para comunicação de um novo processo na plataforma
        será o dobro do tempo de frequência da buscas contratado.
      </li>
      <li>
        <b>Suporte de 1º Nível:</b>
        {' '}
        Trata-se de suporte inicial voltado a orientar o usuário sobre o correto uso do Antecipei,
        a ser realizado na própria ferramenta através do botão identificado com o símbolo (?) ou
        a partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da JURISTEC+
        deverá ser de 1 (um) dia útil.
      </li>
      <li>
        <b>Suporte de 2º Nível:</b>
        {' '}
        Trata-se de suporte voltado à resolução de comportamento inesperado do
        Antecipei, a ser realizado na própria ferramenta através do botão identificado com o
        símbolo (?) ou a partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta
        da JURISTEC+ deverá ser de 5 (cinco) dias úteis.
      </li>
      <li>
        <b>Suporte de 3º Nível:</b>
        {' '}
        Trata-se de suporte voltado a resolver questões relacionadas à indisponibilidade do
        Antecipei, a ser realizado na própria ferramenta através do botão identificado com o símbolo
        (?) ou a partir do e-mail suporte@legalmetrics.com.br. O tempo médio de resposta da
        JURISTEC+ deverá ser de 1 (um) dia útil.
      </li>
    </ul>
    <p>
      A CONTRATANTE declara ter ciência de que, como uma ferramenta de capturas, as consultas do
      Antecipei podem ficar total ou parcialmente indisponíveis em razão de indisponibilidades dos
      sistemas dos tribunais ou de demais fontes públicas. Em tais casos, os serviços da ferramenta
      poderão ficar indisponíveis enquanto durar o período de interrupção total ou parcial dos
      sistemas dos tribunais ou de demais fontes públicas.
    </p>

    <h3 className="section">8. Das Limitações de Responsabilidade</h3>
    <p>
      Exceto pelas garantias especificamente previstas no presente Contrato, a JURISTEC+ não concede
      garantias adicionais quanto ao uso dos softwares ora licenciados. A JURISTEC+ não realizará e
      nem concede qualquer garantia de adequação, customização e/ou parametrização dos softwares ora
      contratados com qualquer sistema da CONTRATANTE.
    </p>
    <p>
      A JURISTEC+ também não garante o uso ininterrupto dos softwares, considerando a dependência de
      serviços de telecomunicações prestados por terceiros e tendo em vista a impossibilidade de
      funcionamento integral e ininterrupto de qualquer sistema de telecomunicação ou de informática
      , durante 365 (trezentos e sessenta e cinco) dias por ano, 24 (vinte e quatro) horas por dia e
      nem que os softwares estarão isentos de erros.
    </p>
    <p>
      Caso a interrupção dos serviços tenha ocorrido em razão de falhas nos sistemas e ferramentas
      da CONTRATADA e, caso o restabelecimento do sistema não ocorra no prazo máximo de 48 (quarenta
      e oito) horas, a CONTRATANTE fará jus ao abatimento proporcional na fatura do mês,
      correspondente ao período de indisponibilidade do sistema.
    </p>
    <p>
      Os softwares contratados poderão sofrer interrupções de até 48 (quarenta e oito) horas por mês
      para manutenções e atualizações, desde que previamente informado à CONTRATANTE mediante
      notificação por e-mail ou aviso na própria plataforma. As manutenções e atualizações, quando
      necessárias, deverão ser realizadas preferencialmente fora do horário comercial e em finais de
      semana, não integrando as hipóteses de abatimento na fatura constantes da cláusula acima.
    </p>
    <p>
      JURISTEC+ não se responsabilizará pela preparação ou adequação das bases de dados da própria
      CONTRATANTE a serem utilizadas nos softwares.
    </p>
    <p>
      A CONTRATANTE declara ter ciência de que NENHUM DOS SOFTWARES E/OU SERVIÇOS ORA CONTRATADOS
      SUBSTITUEM A NECESSIDADE DE ACOMPANHAMENTO JURÍDICO ÀS ATIVIDADES DA CONTRATANTE. Os softwares
      contratados são automatizados e têm a finalidade de apenas facilitar a análise de dados e
      informações disponibilizados pela própria CONTRATANTE e/ou obtidos de fontes públicas. A
      JURISTEC+ não se responsabiliza por erro de dados e/ou informações vindos da própria
      CONTRATANTE ou obtidos de fontes públicas, nem por quaisquer falhas na captura de tais dados e
      informações. Nenhuma informação ou dado disponibilizados nos softwares da JURISTEC+ têm a
      função de substituir informações oficiais vindas de fontes públicas, incluindo, mas não se
      limitando, a informações vindas de tribunais de justiça, diários oficiais e demais entidades
      da administração pública direta ou indireta, não servindo as plataformas da JURISTEC+ como
      instrumentos para controle de prazos processuais e recebimento de citação.
    </p>

    <h3 className="section">9. Da Confidencialidade</h3>
    <p>
      Informação Confidencial. Considera-se como “Informação Confidencial” quaisquer informações e
      dados revelados por uma parte (“Parte Divulgadora”), incluindo seus administradores,
      consultores, auditores, contadores, advogados, contratados, representantes ou empregados,
      podendo ser tangíveis ou intangíveis, transmitidos de qualquer forma, modificados ou não pela
      parte contrária (“Parte Receptora”), incluindo, mas não limitando-se a informações
      disponibilizadas pela Parte Divulgadora à Parte Receptora para inserção nas plataformas dos
      softwares contratados e demais dados, materiais e documentos que venham ser disponibilizados
      pela Parte Divulgadora à Parte Receptora em razão do presente Contrato.
    </p>
    <p>
      Não são consideradas Informações Confidenciais as informações que:
    </p>
    <ol type="I">
      <li>
        forem de conhecimento público ou assim se tornarem de forma outra que não pela divulgação
        pela Parte Receptora;
      </li>
      <li>
        já forem de conhecimento da Parte Receptora quando de sua divulgação pela Parte Divulgadora;
      </li>
      <li>
        forem divulgadas à Parte Receptora por outra fonte que não a Parte Divulgadora, desde que
        tal divulgação não tenha sido feita, no melhor conhecimento da Parte Receptora, em violação
        à obrigação de confidencialidade.
      </li>
    </ol>
    <p>
      A Parte Receptora ficará sujeita às seguintes obrigações:
    </p>
    <ol type="I">
      <li>
        não utilizar as Informações Confidenciais em proveito próprio ou para finalidade outra que
        não àquelas relacionadas ao objeto deste Contrato;
      </li>
      <li>
        manter as Informações Confidenciais em sigilo, divulgando-as apenas a seus administradores,
        empregados, prepostos, sócios, advogados, auditores e demais prestadores de serviços que
        necessitem receber as Informações Confidenciais para fins de avaliação, negociação e
        realização do presente Contrato, durante toda a vigência do presente Contrato e pelo
        período adicional de 5 (cinco) anos do seu término; e
      </li>
      <li>
        zelar pela manutenção do sigilo das Informações Confidenciais, tomando medidas razoáveis
        para proteger sua integridade e evitar sua divulgação.
      </li>
    </ol>
    <p>
      A Parte Receptora poderá divulgar quaisquer Informações Confidenciais caso assim requerido
      pela legislação ou regulamentação a que estiver sujeita, ou por ordem ou decisão judicial,
      administrativa ou arbitral. Neste caso, as Informações Confidenciais divulgadas deverão ser
      as mínimas necessárias para cumprimento da respectiva norma, ordem ou decisão, devendo a
      outra Parte ser informada, quando tal ato não implicar em violação legal.
    </p>

    <h3 className="section">10. Das Obrigações de Integridade</h3>
    <p>
      As partes declaram que cumprem e cumprirão, por toda a vigência do Contrato, as regras
      estabelecidas pelas Leis nº 12.846/2013 (Lei Anticorrupção) e nº 9.613/1998 (Lei de Lavagem
      de Dinheiro), suas respectivas regulamentações e alterações, e demais legislações
      pertinentes, inclusive no que tange ao combate à corrupção e à vedação à prática de
      qualquer ato lesivo à administração pública, nacional ou estrangeira, bem como declaram,
      sem prejuízo das demais obrigações legais, que não fizeram, farão, instruíram ou instruirão
      a entrega, oferta ou promessa, em interesse ou benefício próprio ou de terceiros, direta ou
      indiretamente, de vantagens indevidas para agentes públicos ou a terceira pessoa a eles
      relacionados.
    </p>
    <p>
      As partes, neste ato, declaram ainda que cumprem e cumprirão, por toda a vigência deste
      Contrato, a legislação e regulamentação referente: (a) à saúde e segurança ocupacional do
      trabalhador e de terceiros; (b) ao meio ambiente; (c) à previdência social; (d)
      à livre concorrência; (e) à defesa do consumidor; (f) aos direitos humanos; bem como
      declaram que suas políticas e atividades não permitem ou incentivam a prática de
      prostituição, atos discriminatórios de qualquer natureza, mão de obra infantil e/ou em
      condição análoga à de escravo.
    </p>

    <h3 className="section">11. Dos Preços</h3>
    <p>
      Os valores aplicados pelos serviços e produtos são aqueles constantes do contrato firmado
      com a Juristec.
    </p>
    <p>
      Todos os pagamentos referentes ao contrato assinado devem ser realizados mediante (i)
      boleto bancário; (ii) transferência eletrônica; (iii) cartão de crédito cadastrado; ou
      (iv) outro meio disponível em plataforma de cobrança fornecida pela JURISTEC+.
    </p>
    <p>
      Caso o pagamento seja realizado por transferência eletrônica, deverão ser utilizados os
      seguintes dados bancários da JURISTEC+: CNPJ nº 27.434.472/0001-09, Banco do Brasil (001)
      , Agência 7042, Conta Corrente nº 83088-7.
    </p>
    <p>
      Na contratação de determinado serviço ou produto, a plataforma poderá solicitar as
      informações financeiras do usuário, como CPF, endereço de cobrança e dados de cartões. Ao
      inserir referidos dados o usuário concorda que sejam cobrados, de acordo com a forma de
      pagamento que venha a ser escolhida, os preços então vigentes e informados quando da
      contratação. Referidos dados financeiros poderão ser armazenados para facilitar acessos e
      contratações futuras.
    </p>
    <p>
      A contratação dos serviços será renovada automaticamente pela plataforma, independentemente
      de comunicação ao usuário, mediante cobrança periódica da mesma forma de pagamento indicada
      pelo usuário quando da contratação do serviço.
    </p>

    <h3 className="section">12. Resilição, Rescisão e Encerramento dos Serviços</h3>
    <p>
      O usuário poderá cancelar a contratação dos serviços de acordo com os termos que forem
      definidos no momento de sua contratação. Ainda, o usuário também poderá cancelar os serviços
      em até 7 (sete) dias após a contratação, de acordo com o
      {' '}
      <a
        href="https://www.jusbrasil.com.br/legislacao/91585/c%C3%B3digo-de-defesa-do-consumidor-lei-8078-90"
        target="_blank"
        rel="noopener noreferrer"
      >
        Código de Defesa do Consumidor
      </a>
      {' '}
      (Lei no.
      {' '}
      <a
        href="https://www.jusbrasil.com.br/legislacao/91585/c%C3%B3digo-de-defesa-do-consumidor-lei-8078-90"
        target="_blank"
        rel="noopener noreferrer"
      >
        8.078/90
      </a>
      ).
    </p>
    <p>
      A JURISTEC+ poderá suspender ou encerrar o acesso à plataforma caso seja verificado o
      descumprimento destes Termos de Uso, a utilização da plataforma em desacordo com sua
      finalidade, o fornecimento de informações falsas ou inexatas, a prática de atos que
      comprometam a segurança ou o funcionamento dos sistemas ou qualquer outra conduta que viole
      a legislação aplicável.
    </p>
    <p>
      Também poderá ocorrer o encerramento da relação contratual em casos descumprimento das
      obrigações, declarações e garantias assumidas no Contrato, bem como solicitação, por qualquer
      das Partes, de recuperação judicial, extrajudicial ou declaração de falência, liquidação
      judicial ou extrajudicial.
    </p>
    <p>
      Antes da efetiva rescisão motivada por descumprimento destes Termos de Uso, será concedido
      prazo de até 60 (sessenta) dias para que a irregularidade seja sanada, contados do recebimento
      da respectiva notificação.
    </p>
    <p>
      Caso a irregularidade não seja corrigida dentro do prazo informado, a JURISTEC+ poderá
      efetivar o encerramento dos serviços mediante comunicação formal ao usuário.
    </p>
    <p>
      Em caso de rescisão contratual, a parte prejudicada deverá ser ressarcida mediante o pagamento
      de multa contratual no valor de 3 (três) meses da mensalidade vigente do plano contratado, que
      servirá, para todos os efeitos, nos termos do art. 416 do Código Civil, como cláusula penal em
      substituição a quaisquer prejuízos e/ou perdas e danos ocasionados à outra parte, sendo vedada
      qualquer indenização suplementar.
    </p>
    <p>
      Nenhuma das partes será considerada inadimplente ou estará sujeita às penalidades deste
      Contrato se o inadimplemento decorrer de caso fortuito ou força maior, previstos no artigo 393
      e parágrafo único, do Código Civil brasileiro, e que comprovadamente afetem o cumprimento
      total ou parcial das obrigações ora assumidas.
    </p>
    <p>
      As partes reconhecem que nenhum sistema, servidor ou software está absolutamente imune a
      ataques e/ou invasões de hackers e outros agentes maliciosos (“Ataques Cibernéticos”),
      enquadrando-se nos conceitos de caso fortuito e força maior o Ataque Cibernético sofrido por
      uma parte, no qual ela não poderia razoavelmente evitar por meio de medidas adequadas de
      segurança, segundo padrões de mercado.
    </p>
    <p>
      Em qualquer hipótese, seja resilição ou rescisão do Contrato, a CONTRATANTE ficará obrigada
      ao pagamento dos valores devidos à JURISTEC+ pelos serviços prestados até o término do
      Contrato, incluindo a remuneração devida pelo período de aviso prévio estabelecido.
    </p>

    <h3 className="section">13. Obrigações das Partes</h3>
    <p>
      São obrigações da JURISTEC+:
    </p>
    <ol type="I">
      <li>
        Efetuar a instalação e disponibilizar os softwares licenciados e pacotes adicionais
        contratados na quantidade prevista na Proposta Comercial;
      </li>
      <li>
        Garantir aos usuários da CONTRATANTE o acesso e utilização dos softwares licenciados
        dentro das especificações;
      </li>
      <li>
        Prestar suporte aos usuários da CONTRATANTE nos termos do Acordo de Nível de Serviço
        contratado (“Service Level Agreement – SLA”);
      </li>
      <li>
        Armazenar as informações disponibilizadas pela CONTRATANTE em ambiente seguro,
        considerando os meios tecnológicos disponíveis e adequados às suas atividades, e
        respeitada a confidencialidade das informações da CONTRATANTE;
      </li>
      <li>
        Realizar a prestação dos serviços customizados, quando contratados, dentro do
        escopo e prazo contratados, salvo quando a falta de entrega ou atraso ocorrer por
        culpa da CONTRATANTE.
      </li>
    </ol>
    <p>
      São obrigações da CONTRATANTE:
    </p>
    <ol type="I">
      <li>
        Realizar os pagamentos constantes do Contrato na forma e prazos acordados;
      </li>
      <li>
        Utilizar as licenças de uso concedidas nos estritos termos deste Contrato, sendo
        expressamente vedado:
        <ol type="a">
          <li>
            que colaboradores da CONTRATANTE e/ou demais terceiros sem licença ativada
            utilizem os softwares da CONTRATADA;
          </li>
          <li>
            alugar, arrendar, sublicenciar, emprestar, dar ou de outro modo transferir
            as licenças de uso ora concedidas;
          </li>
          <li>
            copiar, portar, alterar, fazer engenharia reversa, descompilar, ou modificar
            os softwares objeto do presente contrato;
          </li>
        </ol>
      </li>
      <li>
        Fornecer à CONTRATADA as informações e documentos necessários para a utilização
        dos softwares e prestação dos serviços contratados nos termos e prazos solicitados
        pela CONTRATADA.
      </li>
    </ol>
    <p>
      A CONTRATANTE declara e garante:
    </p>
    <ol type="I">
      <li>
        Ter ciência de que a JURISTEC+ é a única titular de todos os direitos de propriedade
        intelectual sobre os softwares. A CONTRATANTE declara ter ciência de que todas as
        customizações, desenvolvimentos, aperfeiçoamentos, atualizações ou implementações aos
        softwares realizados durante a vigência do presente Contrato pertencerão exclusivamente
        à JURISTEC+.
      </li>
      <li>
        Ter ciência de que não há, no presente Contrato, salvo a licença de uso ora concedida,
        nenhuma outra licença implícita ou nada que transfira à CONTRATANTE qualquer titularidade
        sobre os softwares, bem como sobre qualquer direito de propriedade, intelectual ou não,
        da JURISTEC+, incluindo, entre outros, quaisquer códigos-fontes, módulos, bancos de dados,
        softwares, direitos sobre softwares de terceiros, segredos comerciais, marcas, patentes,
        métodos de processamento, interfaces de uso gráfico, técnicas, procedimentos, conceitos,
        formas, imagens, documentação, especificações, linguagens de desenvolvimento, designs,
        fluxogramas ou manuais, incluindo suas evoluções e aperfeiçoamentos.
      </li>
    </ol>

    <h3 className="section">14. Jurisdição Para Resolução de Conflitos</h3>
    <p>
      Para a solução de controvérsias decorrentes do presente instrumento será aplicado
      integralmente o direito brasileiro.
    </p>
    <p>
      Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra
      a sede da
      {' '}
      <b>Juristec</b>
      .
    </p>
  </>
);

export default UseTermsLM;
